// extracted by mini-css-extract-plugin
export default {"profile":"MemberCard_profile__oYcK6","profile__container":"MemberCard_profile__container__r+C55"};